
import { Vue, Component, Prop } from "vue-property-decorator";
import GET_COMPANY from "@/apollo/company/GetCompany.gql";
import CardBodyItem from "@/components/card/CardBodyItem.vue";
import PostingCard from "@/components/jobboard/PostingCard.vue";
import InformationWrapper from "@/components/inforationCards/InformationWrapper.vue";
import InformationCard from "@/components/inforationCards/InformationCard.vue";
import InformationSection from "@/components/inforationCards/InformationSection.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import PageHeadContainer from "@/components/page/PageHeadContainer.vue";
import PageHeadAvatar from "@/components/page/page-head-avatar.vue";
import NotificationOffIcon from "@/components/icons/NotificationOffIcon.vue";
import CompanyNotificationsButton from "@/components/company/CompanyNotificationsButton.vue";
import { Company, Posting, User} from "@/generated/graphql";
import getStateProvinceSelectTitle from "@/helpers/locations/getStateProvinceSelectTitle";

@Component({
  components: {
    CardBodyItem,
    PostingCard,
    LoadingOverlay,
    InformationWrapper,
    InformationCard,
    InformationSection,
    PageHeadContainer,
    PageHeadAvatar,
    NotificationOffIcon,
    CompanyNotificationsButton,
  },
  apollo: {
    company: {
      query: GET_COMPANY,
      variables() {
        return {
          id: this.$route.params.id,
          userId: this.currentUser.id,
        };
      },
      update: (data) => data.company_by_pk,
    },
  },
})
export default class CompanyPublicPage extends Vue {
  @Prop({type: Object, required: true}) readonly currentUser!: User;

  company: Company | null = null;
  showDescriptionPlaceholder: boolean = false;
  notificationsDisabledVal: boolean | null = null;

  get notificationsDisabled(): boolean {
    if (this.notificationsDisabledVal === null) {
      return Boolean(this.company && this.company.users_disabled_notifications.length > 0);
    }
    return this.notificationsDisabledVal!;
  }

  get stateProvinceLabel(): string {
    const country = this.company?.country;
    return getStateProvinceSelectTitle([{id: country!, name: country!}]);
  }

  set notificationsDisabled(status: boolean) {
    this.notificationsDisabledVal = status;
  }

  get postings(): Posting[] {
    return this.company ? this.company.postings : [];
  }

  get companyAddress(): string {
    const address: any[] = [
      this.company?.address1,
      this.company?.address2,
    ];

    return address.filter(el => !!el).join(', ');
  }

  get companyDescription(): string {
    if(!this.company?.description) {
      this.showDescriptionPlaceholder = true;
      return "Company description will be added soon";
    }
    return this.company.description;
  }

  get numberOfEmployees(): number | undefined {
    return this.company?.number_of_employee ? this.company.number_of_employee : undefined;
  }

  get phoneNumber(): number | undefined {
    return this.company?.phone_number ? this.company.phone_number : undefined;
  }

  get website(): string | undefined {
    return this.company?.website ? this.company.website : undefined;
  }

  get companyName(): null | string {
    return this.company?.business_name ? this.company.business_name : null;
  }

  get initials(): string {
    const name = (this.company?.business_name || "").trim();
    return name
      .split(" ")
      .slice(0, 2)
      .map(w => w[0])
      .join();
  }
}
